"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExpanded = exports.isBurgerMenuShown = exports.getSolutions = void 0;
const getSolutions = state => state.menu.solutions;
exports.getSolutions = getSolutions;
const isExpanded = state => state.menu.isExpanded;
exports.isExpanded = isExpanded;
const isBurgerMenuShown = state => Object.values(state.menu.showBurgerMenu ?? {}).some(Boolean);
exports.isBurgerMenuShown = isBurgerMenuShown;